import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Students from './Students';
import {fetchStudentsCount} from 'educator/actions/students';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';

const mapStateToProps = ({
  educator,
  loading,
  studentCounts: {totalStudentsCount = 0, caseloadStudentsCount = 0},
}) => ({
  educator,
  appLoading: loading.default,
  totalStudentsCount,
  caseloadStudentsCount,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setNavigationAnnouncement,
      fetchStudentsCount,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Students);
